// eslint-disable-next-line ember/no-computed-properties-in-native-classes
import { computed } from '@ember/object';
import { scheduleOnce } from '@ember/runloop';
import Component from '@glimmer/component';
import type { Task } from 'ember-concurrency';
import type EntryModel from 'garaje/models/entry';

interface SignOutEntryConfirmModalComponentSignature {
  Args: {
    signOutTask: Task<void, [EntryModel[]]>;
    model: EntryModel[];
    hasGroupParent: boolean;
  };
}

export default class SignOutEntryConfirmModalComponent extends Component<SignOutEntryConfirmModalComponentSignature> {
  @computed('args.{hasGroupParent,model,model.@each.hasAdditionalGuests}')
  get groupParents(): EntryModel[] {
    if (!this.args.hasGroupParent) {
      return [];
    }

    return this.args.model.filter((entry) => entry.hasAdditionalGuests);
  }

  constructor(owner: unknown, args: SignOutEntryConfirmModalComponentSignature['Args']) {
    super(owner, args);
    if (!this.args.hasGroupParent) {
      // eslint-disable-next-line ember/no-incorrect-calls-with-inline-anonymous-functions
      scheduleOnce('afterRender', this, () => {
        void this.args.signOutTask.perform(this.args.model);
      });
    }
  }
}
